<template>
    <div class="InKindPromotionFollowUp">
        <app-breadcrumb />
        <div class="page-container">
            <el-form label-width="auto" label-position="left" class="form-container" size="mini" inline
                style="text-align: left">
                <el-form-item v-if="isAgent" :label="$t('miMember.memberNo')">
                    <el-input size="mini" v-model.trim="listQuery.memberNo" clearable :placeholder="$t('')" />
                </el-form-item>
                <el-form-item>
                    <el-button :loading="doLoading" size="mini" type="primary" icon="el-icon-search" @click="getList">{{
                        $t('function.menu.search') }}
                    </el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="doLoading" :data="list" border fit size="mini" stripe style="width: 100%">
                <el-table-column :label="$t('pdWarehouseStock.companyNo')" prop="companyCode" align="center" />
                <el-table-column :label="$t('miMember.memberNo')" prop="memberNo" align="center" />
                <el-table-column :label="$t('person.name')" prop="memberName" align="center" />
                <el-table-column :label="$t('mi.honourLevel')" prop="levelType" align="center">
                    <template v-slot="{ row }">
                        {{ $lt(initDict.mimemberhonourLevel, row.cardType) }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('commond.levelType')" prop="levelType" align="center">
                    <template v-slot="{ row }">
                        {{ $lt(initDict.mimemberlevel, row.levelType) }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('Phase.1.Community.SmallPerformance')" prop="smallPartSell"
                    align="center" />
                <el-table-column :label="$t('Update.Time')" prop="createTime" align="center" />
            </el-table>
            <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
                @pagination="getList" />
        </div>
    </div>
</template>

<script>

import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination.vue";
import { pageByDTO } from "@/api/rpt/view.js";

export default {
    name: 'InKindPromotionFollowUp',
    components: { Pagination },
    data() {
        return {
            list: [],
            doLoading: false,
            total: 0,
            listQuery: {
                viewName: 'RPT_20260304001',
                page: 1,
                limit: 10,
                memberNo: ''
            },
            initDict: {
                status: 'fi_ac_appl_status_cn',
                mimemberhonourLevel: 'cn.mimember.cardtype',    //荣衔
                mimemberlevel: 'cn.member.level'    //级别
            }
        }
    },

    computed: {
        ...mapGetters([
            'companyCode',
            'isAgent'
        ]),
    },
    created() {
        if (!this.isAgent) {
            this.getList()
        }
    },
    methods: {
        async getList() {
            this.doLoading = true;
            try {
                const res = await pageByDTO(this.listQuery);
                this.list = res.data.records;
                this.total = res.data.total;
            } catch (error) {
                this.$message.error(error);
            } finally {
                this.doLoading = false;
            }
        },
    },


}
</script>

<style lang="scss" scoped></style>